import { memo } from "react";
import Box from "@mui/material/Box";
import LoadingButton from "@mui/lab/LoadingButton";
import { WebRouteTypes } from "consts/enpoints/web";
import { isFormChanged } from "util/forms";
import { Collection } from "ui/support/Resource";
import { NoDataOverlay } from "ui/molecules/TableGrids";
import UnsavedChanges from "ui/layouts/UnsavedChanges";
import useVisiblePaymentMethods from "./useVisiblePaymentMethods";
import PaymentMethod from "./PaymentMethod";
import usePaymentMethodsController from "./usePaymentMethodsController";

const VisiblePaymentMethods = () => {
    const visiblePaymentMethods = useVisiblePaymentMethods();
    const { isLoading, getPaymentMethods } = visiblePaymentMethods;
    const paymentMethods = getPaymentMethods();

    const {
        handleSubmit,
        isSubmitting,
        touched,
        ...form
    } = usePaymentMethodsController(visiblePaymentMethods);

    return (
        <UnsavedChanges
            checkUnsavedChanges={() => isFormChanged({
                ...form,
                touched
            })}
            subscriberKey={WebRouteTypes.PaymentMethods}
        >
            <Box
                component='form'
                onSubmit={handleSubmit}
                sx={{
                    display: 'grid',
                    gap: 2
                }}
            >
                <Collection
                    isLoading={isLoading}
                    isEmpty={!paymentMethods.length}
                    collection={paymentMethods}
                    sx={{
                        display: 'grid',
                        gap: 2
                    }}
                    emptySlot={(
                        <NoDataOverlay>
                            Looks like no payment methods here yet..
                        </NoDataOverlay>
                    )}
                    renderResource={paymentMethod => (
                        <PaymentMethod
                            key={paymentMethod.tag}
                            {...paymentMethod}
                            form={form}
                        />
                    )}
                />
                <LoadingButton
                    type='submit'
                    variant='contained'
                    loading={isLoading || isSubmitting}
                    disabled={!Object.keys(touched).length}
                    sx={{
                        justifySelf: 'flex-start'
                    }}
                >
                    Apply Changes
                </LoadingButton>
            </Box>
        </UnsavedChanges>
    );
};

export default memo(VisiblePaymentMethods);
